var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alreadyCompletedBox"},[_c('p',{staticClass:"alreadyCompletedText"},[_vm._v(" "+_vm._s(_vm.$fanyi("此问卷已完成填写并提交，无需再次填写"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }